import React, { useContext, useState } from "react";
import { Input, Tabs, List, Button, Row, Col, Dropdown ,Modal} from "antd";
import Cmenu from "@/component/Menu";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import Participant from "./Participant";
import useRtc from "@/hooks/use-rtc";
import prompt from "antd-prompt";
import { conference } from "@/api";
import { MeetingContext } from "@/pages/Meeting";
import RtcContext from '@/hooks/use-rtc';
import styled from "styled-components";
import { BoolType, Commond, ParticipantType } from "@/types";
import {eventEmitter} from "@/hooks/use-rtc"
import style from "./style.module.scss";
import { useAuth } from "@/component/Auth";
import { storage } from "@/util";
import { METTINGPAGE_SAVED_MEETING_INFO } from "@/config/const";
import * as meetingtool from "../mtools";
import { is } from "immutable";
import searchIcon from "../../../assets/images/search.svg";
import closeIcon from "../../../assets/images/close-line.svg";

const CloseContainer = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  right: 15px;
  top: 15px;
  font-size: 20px;
  cursor: pointer;
`;

interface ParticipantsProps {
  onParticipantsClose: () => void;
}

const Participants: React.FC<ParticipantsProps> = ({ onParticipantsClose }) => {
  const [keyword, setKeyword] = useState("");
  // const {setParticipants } = useContext(RtcContext);

  const [showApplyTobeHostButton, setShowApplyTobeHostButton] = useState(false);
  const [isPasswordDialogOpen, setIsPasswordDialogOpen] =  useState(false);
  const [passwordValue, setPasswordValue] = useState("");
  let {
    participants,
    conference: conf,
    updateConference,
    setParticipants
  } = useContext(MeetingContext);
  //设法更新上下文里面的 participants
  participants = participants.filter((d: any) => !d.share);
  console.log("participants:::",participants);
  const showPasswordInputDialog = (bShow: boolean) => {
    setIsPasswordDialogOpen(bShow);

    // setShowApplyTobeHostButton(false);
  };

  const handleShowPasswordInputDialogOk = async () => {
    //获取到password,直接再调用加会接口加入会议
     //比对主持人密码
     if (conference.compareHostPwd(conf.conferenceNo,passwordValue,
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      })) {
          //成为主持人 compareHostPwd
           
          conference.conferenceControl(
            {
              // command: Commond.applyHostPermission,
              command: Commond.grant,
              metadata: "",
              seq: "",
              room: conf.roomId,
              from: fromPeer
            },
            {
              "X-Conference-No": conf.conferenceNo,
              "X-Channel-Token": conf["X-Channel-Token"],
              "X-Conference-Token": conf["X-Conference-Token"],
            }
          );
          setShowApplyTobeHostButton(false);
     }
    setIsPasswordDialogOpen(false);
   
  };

  const handleShowPasswordInputDialogCancel = () => {
    setIsPasswordDialogOpen(false);
  };
 
  const passwordValueChange = (e: any) => setPasswordValue(e.target.value);

  const auth = useAuth();
  const { loginfo } = auth;
  const { userId } = loginfo;
  const fromPeer = {
    peerid: userId,
    deviceid: 8,
  };
  React.useEffect(() => {
    eventEmitter.on('automaticNewHostGrant', (peerid, fromid,  ) => {
      // 处理参数
      console.log("Automatically recommend new moderator is ",peerid) 
      console.log("Host is ",fromid) 
      // updateParticipants
      // setParticipants(participants)
      //refresh participants 
      console.log("participants amount is!!!!!!!",participants)
      // refreshParticipants()
      participants.forEach((item: any) => { 
         
        console.log("item.peerid is!!!!!!!",item.peerId)
        console.log(" peerid is!!!!!!!", peerid)
        
        if (item.peerId === peerid) {
          // item.isHost = true;
          // item.roleCode = 20
           
          console.log(" conference is!!!!!!!", conference)
        
          setParticipants((participants: ParticipantType[]) => {
            // 在这里创建一个新的participants数组,专门解决离会主持人不显示问题
            let newParticipants = participants.map((participant: ParticipantType) => {
              if (participant.peerId === peerid) {
                console.log("participant.peerId === peerid is!!!!!!!",peerid)
                return {
                  ...participant,
                  isHost: true,
                  roleCode: 20,
                 
                };
              } else {
                return {
                  ...participant,
                  isHost: false,
                  roleCode: 0,
                };
              }
             
            });
             
            // if (newParticipants.length === 1) {
            //   newParticipants[0].isHost = true;
            //   newParticipants[0].roleCode = 20;
            // }
            return newParticipants;
          });
        } else {
           item.isHost = false;
           item.roleCode =  0
        }
      })
     
       

    });
  }, [])
 React.useEffect(() => {
   const handleHostLeaveMeeting = () => {
     setShowApplyTobeHostButton(true);
   };

   eventEmitter.on('hostLeaveMeeting', handleHostLeaveMeeting);

   // 在组件卸载时移除事件监听器
   return () => {
     eventEmitter.off('hostLeaveMeeting', handleHostLeaveMeeting);
   };
 }, []);
  const muteAll = () => {
    conference.conferenceControl(
      {
        command: Commond.allForceMute,
        metadata: "",
        seq: "",
        room: conf.roomId,
        // to: toPeer,
        from: fromPeer,
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
  };

  const unmuteAll = () => {
    conference.conferenceControl(
      {
        command: Commond.allUnMute,
        metadata: "",
        seq: "",
        room: conf.roomId,
        // to: toPeer,
        from: fromPeer,
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
  };

  const allActions = async (command: Commond) => {
    await conference.conferenceControl(
      {
        command,
        metadata: "",
        seq: "",
        room: conf.roomId,
        // to: toPeer,
        from: fromPeer,
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
  };

  let menuIt: Array<string> = [];
  if (conf.lockedState) menuIt = [...menuIt, "lock"];

  if (conf.muteJoinMetting) menuIt = [...menuIt, "mute"];
  if (conf.allowSelfUnmute) menuIt = [...menuIt, "unMute"];
  if (conf.playTips) menuIt = [...menuIt, "tips"];

  const [menuSelected, setMenuSelected] = React.useState<Array<string>>(menuIt);

  const menuItems = [
    { k: "lock", v: "Хурлыг цоожлох" },
    { k: "mute", v: "Уулзалтад орох үед дууг хаах" },
    { k: "unMute", v: "Уулзалтад орох үед дууг нээх" },
    { k: "tips", v: "Уулзалтад хүн орох үед дохио өгөх" },
    { k: "hand", v: "Бүх хүний гарыг буулгах", c: true },
  ];

  const menuSelectHandler = (
    k: string,
    checked: boolean,
    arr: Array<string>
  ) => {
    let aconf = conf;
    if (k === "lock" && checked) {
      allActions(Commond.lockConference);
      aconf = { ...conf, lockedState: BoolType.yes };
    }
    if (k === "lock" && !checked) {
      allActions(Commond.unLockConference);
      aconf = { ...conf, lockedState: BoolType.no };
    }

    if (k === "mute" && checked) {
      allActions(Commond.openMuteJoinMeeting);
      aconf = { ...conf, muteJoinMetting: BoolType.yes };
    }
    if (k === "mute" && !checked) {
      allActions(Commond.closeMuteJoinMeeting);
      aconf = { ...conf, muteJoinMetting: BoolType.no };
    }

    if (k === "unMute" && checked) {
      allActions(Commond.allowSelfUnmute);
      aconf = { ...conf, allowSelfUnmute: BoolType.yes };
    }
    if (k === "unMute" && !checked) {
      allActions(Commond.forbidSelfUnmute);
      aconf = { ...conf, allowSelfUnmute: BoolType.no };
    }

    if (k === "tips" && checked) {
      allActions(Commond.openPlayTips);
      aconf = { ...conf, playTips: BoolType.yes };
    }
    if (k === "tips" && !checked) {
      allActions(Commond.closePlayTips);
      aconf = { ...conf, playTips: BoolType.no };
    }

    if (k === "hand") {
      allActions(Commond.allHandsDown);
    }

    if (k !== "hand") {
      updateConference(aconf);
      storage.save(METTINGPAGE_SAVED_MEETING_INFO, aconf);
    }

    setMenuSelected([...arr]);
  };

  const menu = React.useMemo(
    () => (
      <Cmenu
        items={menuItems}
        onSelect={menuSelectHandler}
        selectedItems={menuSelected}
      ></Cmenu>
    ),
    [menuSelectHandler, menuSelected]
  );

  const isManage = meetingtool.selfIsManage(conf, participants);

  return (
    <div className={`${style.container} pt20 relative`}>
      <CloseContainer>
        <img className="mr3 ml3" src={closeIcon} alt="lockIcon" onClick={onParticipantsClose} />
      </CloseContainer>
      <div className={style.search}>
        <div className={style.atitle}>Оролцогчид</div>
        <Row gutter={8}>
          <Col flex="1 1 100px">
            <Input
              className={style.input}
              prefix={<img className="mr3 ml3" src={searchIcon} alt="searchIcon" />}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="Хайх"
            />
          </Col>
          {/* <Col flex="0 1 40px">
            <Tooltip title="分享">
              <Button icon={<Icon type="icon-share" />} />
            </Tooltip>
          </Col> */}
        </Row>
      </div>
      <div className={style.tabsContainer}>
        <Tabs>
          <Tabs.TabPane tab={<span style={{ color: "#00AEEF" }}>Бүгд ({participants.length}) </span>} key="1">
            <List itemLayout="horizontal">
              {/* {participants
                .filter((d: any) => !keyword || d.peerName.includes(keyword))
                .map((d: any, i: number) => (
                  
                  <Participant key={i} participant={d} />
                ))} */}
                {participants
                  .filter((d: ParticipantType) => !keyword || d.peerName.includes(keyword))
                  .map((d: ParticipantType, i: number) => {
                    // 如果participants只有一项，将isHost设为false
                    // if (participants.length === 1) {
                    //   d.isHost = true;
                    //   d.roleCode = 20;
                    // }

                    return <Participant key={i} participant={d} />;
                  })}
            </List>
          </Tabs.TabPane>
          {/* <Tabs.TabPane tab={`建议(0)`} key="2">
            <Empty />
          </Tabs.TabPane> */}
        </Tabs>
      </div>
      <div className="h45 pl10 pr10 jssb">
          <div className="fac">
            <Modal
                title="Нууц үгээ оруулна уу"
                width={300}
                centered
                visible={isPasswordDialogOpen}
                onOk={handleShowPasswordInputDialogOk}
                onCancel={handleShowPasswordInputDialogCancel}
                okText="Хост болох хүсэлт илгээх "
                cancelText="Болих"
              >
                <Input
                  value={passwordValue}
                  onChange={passwordValueChange}
                  placeholder="Уулзалтын нууц үг"
                />
            </Modal>
              {showApplyTobeHostButton && (
                
                <Button 
                block
                type="primary"
                onClick={async () => {
                  showPasswordInputDialog(true);
                  // 在这里处理按钮的点击事件
                  // setShowApplyTobeHostButton(false);
                }}>
                  Host болох хүсэлт илгээх
                </Button>
              )}
          </div>
        </div>
      {isManage && (
        <div className="h45 pl10 pr10 jssb">
          <div className="fac">
          
            {/* <Button block onClick={muteAll} size="small" danger type="primary">
              全员静音
            </Button>
            <Button
              block
              onClick={unmuteAll}
              className="ml5"
              size="small"
              type="primary"
            >
              取消全员静音
            </Button> */}
          </div>
          {/* <div>
            <Dropdown overlay={menu}>
              <Button block onClick={unmuteAll} className="ml5" size="small">
                更多操作
              </Button>
            </Dropdown>
          </div> */}
        </div>
      )}
    </div>
  );
};

export default Participants;
